import { getContentTypeLabel, getContentCategoryLabel } from '../../../constants/suggestions'

/**
 * Öneri verilerini görüntüleme için formatlar
 * @param {Object} suggestion - Format edilecek öneri verisi
 * @returns {Object} Formatlanmış öneri verisi
 */
export const formatSuggestionForDisplay = (suggestion) => {
  if (!suggestion) return null

  return {
    ...suggestion,
    contentTypeLabel: getContentTypeLabel(suggestion.contentType),
    contentCategoryLabel: getContentCategoryLabel(suggestion.contentCategory),
    createdAtFormatted: new Date(suggestion.createdAt).toLocaleString('tr-TR'),
    updatedAtFormatted: new Date(suggestion.updatedAt).toLocaleString('tr-TR'),
  }
}

/**
 * Öneri listesini görüntüleme için formatlar
 * @param {Array} suggestions - Format edilecek öneri listesi
 * @returns {Array} Formatlanmış öneri listesi
 */
export const formatSuggestionsForDisplay = (suggestions) => {
  if (!suggestions || !Array.isArray(suggestions)) return []

  return suggestions.map(suggestion => formatSuggestionForDisplay(suggestion))
}

/**
 * API'ye göndermeden önce öneri verilerini formatlar
 * @param {Object} suggestionData - Format edilecek öneri verisi
 * @returns {Object} API için formatlanmış öneri verisi
 */
export const formatSuggestionForSubmission = (suggestionData) => {
  const formattedData = { ...suggestionData }

  // Boş değerleri null olarak ayarla
  if (formattedData.currentImageUrl === '') {
    formattedData.currentImageUrl = null
  }

  if (formattedData.currentVideoUrl === '') {
    formattedData.currentVideoUrl = null
  }

  if (formattedData.currentText === '') {
    formattedData.currentText = null
  }

  // URL'leri düzelt ve kontrol et
  if (formattedData.currentImageUrl) {
    try {
      new URL(formattedData.currentImageUrl)
    } catch (e) {
      // URL formatı geçersizse ve http/https protokolü yoksa ekle
      if (!formattedData.currentImageUrl.startsWith('http')) {
        formattedData.currentImageUrl = 'https://' + formattedData.currentImageUrl
        console.log('Görsel URL düzeltildi:', formattedData.currentImageUrl)
      }
    }
  }

  if (formattedData.currentVideoUrl) {
    try {
      new URL(formattedData.currentVideoUrl)
    } catch (e) {
      // URL formatı geçersizse ve http/https protokolü yoksa ekle
      if (!formattedData.currentVideoUrl.startsWith('http')) {
        formattedData.currentVideoUrl = 'https://' + formattedData.currentVideoUrl
        console.log('Video URL düzeltildi:', formattedData.currentVideoUrl)
      }
    }
  }

  // Öncelik değerini sayıya çevir
  if (formattedData.priority !== undefined) {
    formattedData.priority = parseInt(formattedData.priority)
  }

  return formattedData
}
